<template>
    <v-card>
        <v-card-text class="text--primary">
            <v-container fluid>
                <v-row no-gutters>
                    <v-col cols="12" sm="4">
                        <v-menu
                                v-model="createdFromMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="createFromFormatted"
                                        label="Created from"
                                        class="case-filter-item"
                                        prepend-icon="event"
                                        readonly
                                        clearable
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="createdFrom" @input="createdFromMenu = false"
                                           first-day-of-week="1"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-menu
                                v-model="createdToMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="createToFormatted"
                                        label="Created to"
                                        class="case-filter-item"
                                        prepend-icon="event"
                                        readonly
                                        clearable
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="createdTo" @input="createdToMenu = false"
                                           first-day-of-week="1"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-autocomplete
                                :items="filteredClients"
                                v-model="clientIds"
                                item-text="title"
                                item-value="id"
                                class="case-filter-item"
                                no-data-text="No clients"
                                label="Please, select clients"
                                multiple
                                small-chips
                                deletable-chips
                                clearable
                        >
                            <template
                                    slot="selection"
                                    slot-scope="data"
                            >
                                <v-chip
                                        close
                                        class="chip--select-multi v-chip--small"
                                        @click:close="removeClientFromFilter(data.item)"
                                >
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">{{ data.item.shortTitle | NoEmpty}}</span>
                                        </template>
                                        <span>{{ data.item.title | NoEmpty}}</span>
                                    </v-tooltip>
                                </v-chip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" sm="4">
                        <v-text-field
                                v-model="searchString"
                                label="Search by name / email / partner name / case number"
                                class="case-filter-item"
                                text
                        >
                            <v-tooltip slot="append" bottom>
                                <template v-slot:activator="{ on }">
                                    <v-checkbox v-on="on" class="search-strict-checkbox" v-model="strictSearch">
                                    </v-checkbox>
                                </template>
                                <span>Strict search</span>
                            </v-tooltip>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete
                                :loading="batchesProgress('getAllBatches')"
                                :disabled="batchesProgress('getAllBatches')"
                                :items="allBatches"
                                v-model="batchId"
                                item-text="systemId"
                                item-value="id"
                                class="case-filter-item"
                                no-data-text="No plates"
                                label="Please, select plate"
                                clearable
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete
                                :items="availableSpecialists"
                                v-model="needSignBy"
                                item-text="name"
                                item-value="id"
                                class="case-filter-item"
                                no-data-text="No specialists"
                                label="Please, select the specialist to sign"
                                clearable
                        >
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" sm="4">
                        <v-select
                                ref="sampleStatusSelector"
                                class="case-filter-item"
                                v-model="sampleStatuses"
                                :items="availableSampleStatuses"
                                item-text="title"
                                item-value="value"
                                label="Sample statuses"
                                multiple
                                clearable
                                small-chips
                                deletable-chips
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-checkbox
                          class="case-filter-item"
                          label="Show cases without documents"
                          v-model="showCasesWithoutDocuments"
                      ></v-checkbox>
                    </v-col>
<!--                    <v-flex xs12 sm4>-->
<!--                        <v-select-->
<!--                                ref="reportStatusSelector"-->
<!--                                class="case-filter-item"-->
<!--                                v-model="reportStatuses"-->
<!--                                :items="availableReportStatuses"-->
<!--                                item-text="title"-->
<!--                                item-value="value"-->
<!--                                label="Report statuses"-->
<!--                                multiple-->
<!--                                clearable-->
<!--                        ></v-select>-->
<!--                    </v-flex>-->
                </v-row>
                <v-row no-gutters>
                    <v-col>
                        <cases-list/>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import _ from 'lodash'
    import CasesList from '../Components/List'
    import NoEmpty from '../../Filters/NoEmpty'
    import {reformatDate} from '../../../helpers/timeformats'
    import {mapActions, mapGetters, mapState} from 'vuex'

    export default {
        name: "Cases",
        components: {
            CasesList
        },
        filters: {
            NoEmpty
        },
        data() {
            return {
                createdFromMenu: false,
                createdToMenu: false
            }
        },
        mounted() {
            this.getAllBatches()
        },
        computed: {
            ...mapState({
                availableSpecialists: 'availableSpecialists'
            }),
            ...mapState('pgtCases', {
                filters: 'filters',
                availableReportStatuses: 'availableReportStatuses',
                availableSampleStatuses: 'availableSampleStatuses'
            }),
            ...mapState('clients', {
                clients: 'clients'
            }),
            ...mapState('batches', {
                allBatches: 'allBatches'
            }),
            ...mapGetters('batches', {
                batchesProgress: 'progress'
            }),
            filteredClients() {
                let result = []
                for (let client of this.clients) {
                    result.push({
                        id: client.id,
                        title: client.title,
                        shortTitle: _.truncate(client.title, {
                            length: 15
                        })
                    })
                }

                return result
            },
            searchString: {
                get() {
                    return this.filters.searchString
                },
                set: _.debounce(function (value) {
                    let resultValue = null
                    if (value.length > 0) {
                        resultValue = value
                    }

                    this.changeSearchStringFilter(resultValue)
                }, 500),
            },
            strictSearch: {
                get() {
                    return this.filters.strictSearch
                },
                set: function (value) {
                    this.changeStrictSearchFilter(value)
                },
            },
            createdFrom: {
                get() {
                    return this.filters.createdFrom
                },
                set: function (value) {
                    this.changeCreatedFromFilter(value)
                },
            },
            createFromFormatted: {
                get() {
                    return reformatDate(this.filters.createdFrom)
                },
                set(value) {
                    this.changeCreatedFromFilter(value)
                }
            },
            createdTo: {
                get() {
                    return this.filters.createdTo
                },
                set: function (value) {
                    this.changeCreatedToFilter(value)
                },
            },
            createToFormatted: {
                get() {
                    return reformatDate(this.filters.createdTo)
                },
                set(value) {
                    this.changeCreatedToFilter(value)
                }
            },
            clientIds: {
                get() {
                    return this.filters.clientIds
                },
                set: function (value) {
                    this.changeClientsFilter(value)
                },
            },
            batchId: {
                get() {
                    return this.filters.batchId
                },
                set: function (value) {
                    this.changeBatchFilter(value)
                },
            },
            showCasesWithoutDocuments: {
                get() {
                    return this.filters.showCasesWithoutDocuments
                },
                set: function (value) {
                    this.changeShowCasesWithoutDocumentsFilter(value)
                },
            },
            reportStatuses: {
                get() {
                    return this.filters.reportStatuses
                },
                set: function (value) {
                    this.changeReportStatusesFilter(value)
                },
            },
            sampleStatuses: {
                get() {
                    return this.filters.sampleStatuses
                },
                set: function (value) {
                    this.changeSampleStatusesFilter(value)
                },
            },
            needSignBy: {
              get() {
                return this.filters.needSignBy
              },
              set: function (value) {
                this.changeNeedSignByFilter(value)
              },
            },
        },
        methods: {
            ...mapActions('pgtCases', {
                changeSearchStringFilter: 'changeSearchStringFilter',
                changeStrictSearchFilter: 'changeStrictSearchFilter',
                changeCreatedFromFilter: 'changeCreatedFromFilter',
                changeCreatedToFilter: 'changeCreatedToFilter',
                changeClientsFilter: 'changeClientsFilter',
                changeBatchFilter: 'changeBatchFilter',
                changeNeedSignByFilter: 'changeNeedSignByFilter',
                changeShowCasesWithoutDocumentsFilter: 'changeShowCasesWithoutDocumentsFilter',
                changeReportStatusesFilter: 'changeReportStatusesFilter',
                changeSampleStatusesFilter: 'changeSampleStatusesFilter'
            }),
            ...mapActions('batches', {
                getAllBatches: 'getAllBatches'
            }),
            removeClientFromFilter(item) {
                let clientIds = _.cloneDeep(this.filters.clientIds)
                const index = clientIds.indexOf(item.id)

                if (index >= 0) {
                    clientIds.splice(index, 1)
                }

                this.changeClientsFilter(clientIds)
            },
            reformatDate: reformatDate
        }
    }
</script>

<style scoped>
    .case-filter-item {
        margin-left: 10px !important;
        margin-right: 10px !important;
    }
</style>

<style>
    .search-strict-checkbox .v-input__slot {
        margin-bottom: 0px !important;
    }

    .search-strict-checkbox.v-input--selection-controls {
        margin-top: 0px !important;
        padding-top: 0px !important;
    }

    .search-strict-checkbox .v-messages {
        display: none;
    }
</style>